import { render, staticRenderFns } from "./Refresh.vue?vue&type=template&id=32cb0c74"
import script from "./Refresh.vue?vue&type=script&lang=js"
export * from "./Refresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports